export const loadGoogleSdk = () => {
    (() => {
        if (
            !document.getElementById('google-one-tap-script') &&
            !document.getElementById('credential_picker_container') &&
            !document.getElementById('google-auth-script')
        ) {
            const element = document.getElementsByTagName('script')[0];
            const sdk = document.createElement('script');
            sdk.src = `https://accounts.google.com/gsi/client`;
            sdk.async = true;
            sdk.defer = true;
            sdk.id = 'google-auth-script';
            element?.parentNode?.insertBefore(sdk, element);
        }
    })();
};
